import React from 'react'
import PropTypes from 'prop-types'

import Checkbox from '@material-ui/core/Checkbox'
import Switch from '@material-ui/core/Switch'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormHelperText from '@material-ui/core/FormHelperText'

import { Controller } from 'react-hook-form'

import { createMuiTheme } from '@material-ui/core'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'

// mark the required asterixes in red - see https://stackoverflow.com/questions/54936644/how-to-change-the-asterisk-color-in-required-field
const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: '#db3131',
        '&$error': {
          color: '#db3131'
        }
      }
    }
  }
})

export default function ValidatedCheckbox (props) {
  const {
    control, // returned from the useForm hook
    errors, // get this via formState: { errors } from the useForm hook
    name, // name should match the defaultVales field of the useForm object we are linked to via the control
    label,
    helperText = '',
    rules = {}, // in the format of useForm register rules - disabled rule will also pass through to the TextField object
    type = 'checkbox'
  } = props

  let disabled = false

  if (rules.disabled) {
    disabled = rules.disabled
  }

  return (
    <MuiThemeProvider theme={formLabelsTheme}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <FormControl error={!!errors[name]}>
            <FormControlLabel
              control={
                type === 'checkbox'
                  ? <Checkbox checked={field.value} onChange={(event) => field.onChange(event.target.checked)} style={{ color: disabled ? 'grey' : '#0e70fb' }}/>
                  : <Switch checked={field.value} onChange={(event) => field.onChange(event.target.checked)} color="primary" />
              }
              disabled={disabled}
              label={<Typography style={{ color: '#6d6d6d' }}>{label}</Typography>}
              style={{ color: '00008a', marginTop: '12px' }}
            />
            <FormHelperText style={{ marginTop: type === 'checkbox' ? '-3px' : 0 }}>{errors[name] ? errors[name].message : helperText}</FormHelperText>
          </FormControl>
        )}
      />
    </MuiThemeProvider>
  )
}

ValidatedCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  rules: PropTypes.object,
  fullWidth: PropTypes.bool,
  type: PropTypes.oneOf(['checkbox', 'switch'])
}
